/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { transformTimeToAgoString } from './utils';

import type { TimeAgoColumnLang } from './interfaces';

export interface TimeAgoColumnProps {
    value: Date | string | null;
    lang: TimeAgoColumnLang;
}

export const TimeAgoColumn = ({ value, lang }: TimeAgoColumnProps) => (
    <>
        {transformTimeToAgoString(value, lang)}
    </>
);
